export interface ConversationsDetailsProps {
  className?: string;
}

export enum TabsValuesTypes {
  details = 'details',
  files = 'files',
}
